import '../../scss/ExamDetail.scss'
import TypeNoi from './typequestion/TypeNoi';
import { ProgressSpinner } from 'primereact/progressspinner';

export default function ExamNoiDetail(props) {

    const { indexDF, socauhoi, dataQuestion, loading, indexNhom, onSubmitAnswer, onAutoNext } = props;
    return (
        <>
            <div className="conatiner-div1 mb-3">
                <div>
                    <h2 className="title">Speaking</h2>
                </div>
                <div>
                    <div className="row">
                        <div className="col-12 col-sm-6 col-md-8">
                            <h2 className="title"> Part {indexDF + 1} of {socauhoi} </h2>
                        </div>
                    </div>
                </div>

            </div>
            {loading ?
                <div style={{ textAlign: 'center' }}>
                    <ProgressSpinner />
                </div>
                :
                <div >
                    <div className="conatiner-div1" >
                        <div style={{ marginBottom: '100px' }}>
                            <TypeNoi
                                data={dataQuestion}
                                indexCauHoi={indexDF}
                                indexNhom={indexNhom}
                                onSubmitAnswer={onSubmitAnswer}
                                onAutoNext={onAutoNext}
                            ></TypeNoi>
                        </div>
                    </div>
                </div>
            }

        </>
    )
}
